import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { ChartContainer } from '../../../../../../common/chart/chartContainer'
import Bar from '../../../../../../common/chart/chartContainer/Bar'
import Line from '../../../../../../common/chart/chartContainer/Line'
import { getYAxisNumberProps } from '../../../../../../common/chart/chartContainer/helper'
import { LegendItem } from '../../../../../../common/chart/legend/LegendItem'
import { UseTypeFontSize } from '../../../../../../common/hooks/useTypeFontSize'
import { Element } from '../../../../../../common/html/element'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { getUnique } from '../../../../../../helpers/common'
import { formatVal } from '../../../../../../helpers/value'
import { selectIndicatorById } from '../store/slice'
import { RATIO_CODE } from './constant'

const ChartRight = ({ data, isDynamicReport }) => {
  const chartId1 = useRef(getUnique())
  const chartId2 = useRef(getUnique())

  const typeFontSize = UseTypeFontSize()
  const { formatedUnit, formatValueWithUnit, decimalLength } =
    useFormatCurrency(SCREEN.FINANCIAL_ANALYSIS)
  const indicatorById = useSelector(selectIndicatorById)
  const locale = useSelector((state) => state.i18n.locale)

  const propYAxis = {
    yAxisId: 'left',
    dataKeys: [RATIO_CODE.ALLOWANCE_EXPENSES],
    isBarChart: true,
    decimalLength,
  }

  const { width } = getYAxisNumberProps(data, propYAxis, typeFontSize)

  const isSmallScreen = window.innerWidth < 1200

  return (
    <>
      <div className="h30 pb1 dFlex">
        <div className="h100 dFlex alignItemsCenter" style={{ width }}>
          <Element style={{ color: '#C4D886' }}>
            {indicatorById[RATIO_CODE.CREDIT_COST]?.ratioName}
          </Element>
        </div>
        <div className="flex1 minW0 h100">
          <ChartContainer
            chartId={chartId1.current}
            data={data}
            margin={{
              top: 15,
              left: isDynamicReport ? 16 : 0,
              bottom: 0,
              right: 0,
            }}
            width="100%"
            height="100%"
            cartesianGrid={{
              vertical: false,
              horizontal: false,
            }}
            xAxis={[
              {
                dataKey: 'year',
                hide: true,
              },
            ]}
            yAxis={[
              {
                yAxisId: 'left',
                dataKeys: [RATIO_CODE.CREDIT_COST],
                isLineChart: true,
                hide: true,
              },
            ]}
            tooltip={{
              schema: {
                content: [
                  {
                    dataKey: RATIO_CODE.CREDIT_COST,
                    label: indicatorById[RATIO_CODE.CREDIT_COST]?.ratioName,
                    formatValue: (value) => formatVal(value, locale, true),
                    unit: '%',
                  },
                ],
              },
              position: isSmallScreen ? { x: -35 } : undefined,
            }}
          >
            <Bar
              yAxisId="left"
              dataKey={'dummy'}
              fill="#006AA600"
              showLabelEmpty={false}
            />
            <Line
              yAxisId="left"
              dataKey={RATIO_CODE.CREDIT_COST}
              stroke="#C4D886"
              dot={{ fill: '#83A04C' }}
              // label={
              //   <CustomizedLabelLine
              //     style={{ fontSize: 10 }}
              //     formatValue={(value) => valToPercent(value, locale, true)}
              //   />
              // }
            />
          </ChartContainer>
        </div>
      </div>
      <div className="h70 pt1 flexColumn">
        <Element style={{ paddingBottom: 4, color: '#9C9C9C' }}>
          {formatedUnit}
        </Element>
        <div className="h100 pb1">
          <ChartContainer
            chartId={chartId2.current}
            data={data}
            margin={{
              top: 10,
              left: 0,
              bottom: 0,
              right: 0,
            }}
            width="100%"
            height="100%"
            xAxis={[
              {
                dataKey: 'year',
                type: 'category',
                tickFormatter: (year) => '‘' + String(year).slice(2, 4),
              },
            ]}
            yAxis={[propYAxis]}
            tooltip={{
              schema: {
                content: [
                  {
                    dataKey: RATIO_CODE.ALLOWANCE_EXPENSES,
                    label:
                      indicatorById[RATIO_CODE.ALLOWANCE_EXPENSES]?.ratioName,
                    formatValue: (value) => formatValueWithUnit({ value }),
                  },
                ],
              },
              position: isSmallScreen ? { x: -15 } : { x: 40 },
            }}
          >
            <Bar
              yAxisId="left"
              dataKey={RATIO_CODE.ALLOWANCE_EXPENSES}
              fill="#006AA6"
              maxBarSize={35}
            />
          </ChartContainer>
        </div>
        <LegendItem
          title={indicatorById[RATIO_CODE.ALLOWANCE_EXPENSES]?.ratioName}
          isI18n={false}
          color="#006AA6"
        />
      </div>
    </>
  )
}

export default ChartRight
